import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { EquipmentType } from '../../Equipment/EquipmentType';

export type EquipmentConfiguration = {
  id: string;
  equipmentTypes: string[];
  excludedEquipmentTypes: string[];
  readonly isFree: boolean;
  readonly isGym: boolean;
  readonly isCustom: boolean;
  toggleSelection(type: EquipmentType): void;
};

export function createEquipmentConfiguration(json?: Partial<EquipmentConfiguration>): EquipmentConfiguration {
  return makeAutoObservable({
    id: json?.id ?? UUID(),
    equipmentTypes: json?.equipmentTypes || [],
    excludedEquipmentTypes: json?.excludedEquipmentTypes || [],

    get isFree(): boolean {
      const hasFree = this.equipmentTypes.includes('FREE');
      const hasFreeOutdoor = this.equipmentTypes.includes('FREE_OUTDOOR');
      return (
        (this.equipmentTypes.length === 1 && (hasFree || hasFreeOutdoor)) ||
        (this.equipmentTypes.length === 2 && hasFree && hasFreeOutdoor)
      );
    },

    get isGym(): boolean {
      return this.equipmentTypes.length === 0;
    },

    get isCustom(): boolean {
      return this.id !== 'free' && this.id !== 'gym';
    },

    toggleSelection(type: EquipmentType) {
      const index = this.equipmentTypes.findIndex((t) => t === type.id);
      if (index === -1) {
        this.equipmentTypes.push(type.id);
      } else {
        this.equipmentTypes.splice(index, 1);
      }
    },
  });
}

export const EquipmentConfigurationPresets = {
  gym: () => createEquipmentConfiguration({ id: 'gym' }),
  free: () => createEquipmentConfiguration({ id: 'free', equipmentTypes: ['FREE', 'FREE_OUTDOOR'] }),
};
